import * as localStorage from "./local";
import * as sessionStorage from "./session";

let storageLocked = false;

export function tokenPayload(jwt) {
  try {
    const segment = jwt.split(".")[1];
    const json = atob(segment.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
}

export function authContextFromToken(jwt) {
  const payload = tokenPayload(jwt);
  if (!payload?.sid) return null;
  return {
    sid: payload.sid,
    gen: payload.gen,
    companyId: payload.companyId,
  };
}

export function sameAuthContext(before, after) {
  if (!before || !after) return false;
  return (
    String(before.sid) === String(after.sid) &&
    String(before.gen) === String(after.gen) &&
    String(before.companyId) === String(after.companyId)
  );
}

export function shouldKeepSignedIn(explicit) {
  if (typeof explicit === "boolean") return explicit;
  return localStorage.getItem(localStorage.KEEP_SIGNED_IN_KEY) === "true";
}

export function lockAuthStorage() {
  storageLocked = true;
  localStorage.setItem(localStorage.AUTH_LOCKED_KEY, "1");
}

export function isAuthStorageLocked() {
  return (
    storageLocked ||
    localStorage.getItem(localStorage.AUTH_LOCKED_KEY) === "1"
  );
}

export function unlockAuthStorage() {
  storageLocked = false;
  localStorage.removeItem(localStorage.AUTH_LOCKED_KEY);
}

export function persistAuthSession({ jwt }) {
  unlockAuthStorage();
  window.sessionStorage.removeItem("cd_boot_once");
  if (!jwt || !tokenPayload(jwt)?.sid) return;
  sessionStorage.setItem(sessionStorage.AUTH_TOKEN_KEY, jwt);
  localStorage.removeItem(localStorage.AUTH_TOKEN_KEY);
}

export function persistRotatedSession({ jwt }) {
  if (isAuthStorageLocked()) return false;
  if (!jwt || !tokenPayload(jwt)?.sid) return false;
  window.sessionStorage.removeItem("cd_boot_once");
  sessionStorage.setItem(sessionStorage.AUTH_TOKEN_KEY, jwt);
  return true;
}

export function getAccessToken() {
  const jwt = sessionStorage.getItem(sessionStorage.AUTH_TOKEN_KEY);
  if (!jwt || !tokenPayload(jwt)?.sid) {
    if (jwt) sessionStorage.removeObject(sessionStorage.AUTH_TOKEN_KEY);
    return null;
  }
  return jwt;
}

export function getRefreshToken() {
  return localStorage.getItem(localStorage.REFRESH_TOKEN_KEY);
}

export function clearLegacyRefreshToken() {
  localStorage.removeItem(localStorage.REFRESH_TOKEN_KEY);
  localStorage.removeItem(localStorage.KEEP_SIGNED_IN_KEY);
  localStorage.removeItem(localStorage.AUTH_TOKEN_KEY);
}

localStorage.removeItem(localStorage.AUTH_TOKEN_KEY);
